import React from "react";
// react plugin that creates an input with badges
import {globals,stat_form} from '../Globals/Globals'
import {useSelector, useDispatch } from 'react-redux';
import { closeModalStat } from '../../redux/modalSlice'; 
import { updateStat, addStat } from '../../redux/statSlice';
import {Button, Container } from "reactstrap";
import { openModal } from "../../redux/modalSlice";

// core components
import {DsDynamicForm} from "datasync-dynamic-form";
import "../../Components/Modal/Modal.css";

const StatFormDialog = () => {
  const {statModal} = useSelector((state) => state.modal);
  const user_foreign_keys = useSelector((state) => state.auth.user_guid);
  const dispatch = useDispatch();
  const {isAdmin} = useSelector((state) => state.auth);
  const {isReadOnly} = useSelector((state) => state.modal);

  React.useEffect(() => {
    console.log("statModal -> ",statModal);
    console.log("statModal.activeObject -> ",statModal.activeObject);
    console.log("user_foreign_keys ->",user_foreign_keys);

    return function cleanup() {
      document.body.classList.remove("discover");
    };
  });

  return (
      <>
        <div className="main modal-overlay">
          <Button className="modal-top-right-close-button" onClick={()=>{dispatch(closeModalStat())}}>Fermer</Button>
          <div className="dialog-container">
            <Container>
              {statModal.activeObject &&
              <h1>{statModal.activeObject.data_blob.data_tier.stat_title}</h1>}
              {statModal.activeObject===null &&
              <h1>{"<Nouvelle statistique>"}</h1>}
              
              <DsDynamicForm
                col_lg={12}
                datasync_url = {globals.datasync_service.url}
                form = {stat_form}
                company_guid = {globals.datasync.platform_company_guid}
                table_guid= {globals.datasync.pf_stats_table_guid}
                onFormSaved = {(saved_data) => {dispatch(openModal({title:"Formulaire de statistiques enregistré"})); console.log("StatFormDialog::saved_data ->",saved_data);dispatch(addStat(saved_data)); dispatch(closeModalStat());}}
                //Let us update the stat
                onFormUpdated = {(updated_data) => {dispatch(openModal({title:"Formulaire de statistiques modifié"})); console.log("StatFormDialog::updated_data ->",updated_data); dispatch(updateStat(updated_data)); dispatch(closeModalStat());}}
                onFormFailed = {() => {if (globals.parameters.save_failed_alert) dispatch(openModal({title:"Erreur de sauvegarde du formulaire de statistiques"}))}}
                clearOnSave = {true}
                clearOnUpdate = {true}
                sticky_button = {true}
                custom_button_handler = {() => {dispatch(closeModalStat())}}
                custom_button_caption = {"Fermer"}
                //---
                datasync_object = {statModal.activeObject}
                data_blob = {statModal.activeObject?statModal.activeObject.data_blob:null}
                show_hidden = {isAdmin}
                foreign_keys = {statModal.activeObject==null?{"user_guid":user_foreign_keys}:null}
                read_only = {isReadOnly}
              />
            </Container>
          </div>
        </div>
      </>
    );
  }

export default StatFormDialog;
